<div class="flex-space-between">
  @if (tabs?.length) {
    <app-tabs
      [tabs]="tabs">
    </app-tabs>
  }

  @if (authService.isBasicSupportUser) {
    <div class="action-header_container">
      @if (buttonList?.length) {
        <app-button-list
          [list]="buttonList">
        </app-button-list>
      }
    </div>
  }
</div>

<br>

  <app-data-grid
    [data]="gridData$ | async"
    [loading]="isLoading"
    [filterable]="true"
    [filter]="filter"
    (filterChange)="filterChange($event)"
    [sortable]="true"
    [sort]="sort"
    (sortChange)="sortChange($event)"
    [pageable]="true"
    [pageSize]="pageSize"
    [skip]="skip"
    (pageChange)="pageChange($event)"
    [height]="700">
    <app-data-grid-column
      field="last_name"
      title="{{ 'lastName' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="first_name"
      title="{{ 'firstName' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="email"
      title="{{ 'email' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    @if (authService.isBasicSupportUser) {
      <app-data-grid-column
        field="username"
        title="{{ 'username' | translate | titlecase }}">
        <ng-template appGridFilterCellTemplate let-filter let-column="column">
          <app-grid-string-filter
            [column]="column"
            [filter]="filter"
            [operators]="['contains', 'eq', 'startswith', 'endswith']">
          </app-grid-string-filter>
        </ng-template>
      </app-data-grid-column>
    }
    <app-data-grid-column
      field="groups"
      title="{{ 'group' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="office_group"
      title="{{ 'officeGroup' | translate | titlecase }}">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-string-filter
          [column]="column"
          [filter]="filter"
          [operators]="['contains', 'eq', 'startswith', 'endswith']">
        </app-grid-string-filter>
      </ng-template>
    </app-data-grid-column>
    <app-data-grid-column
      field="date_joined"
      title="{{ 'dateJoined' | translate | titlecase }}"
      filter="date">
      <ng-template appGridFilterCellTemplate let-filter let-column="column">
        <app-grid-date-filter
          [column]="column"
          [filter]="filter"
          [operators]="['gte', 'lte']">
        </app-grid-date-filter>
      </ng-template>
      <ng-template appGridCellTemplate let-dataItem>
        {{dataItem.date_joined | date: 'MM/dd/yyyy'}}
      </ng-template>
    </app-data-grid-column>

    @if (authService.isBasicSupportUser) {
      <app-data-grid-command-column>
        <ng-template appGridCellTemplate let-dataItem>
          <button class="dg-btn" [matMenuTriggerFor]="actionsMenu">
            {{'actions' | translate | titlecase}}
            <i class="fas fa-chevron-down"></i>
          </button>
          <mat-menu #actionsMenu="matMenu">
            @for (action of getActionsForUser(dataItem); track action.type) {
              <button
                mat-menu-item
                (click)="onActionClick(action, dataItem)">
                {{ action.actionName }}
              </button>
            }
          </mat-menu>
        </ng-template>
      </app-data-grid-command-column>
    }
  </app-data-grid>

  @if (!!userToChangeEmail) {
    <app-change-email
      [user]="userToChangeEmail"
      (onSubmit)="getUsers()"
      (onClose)="userToChangeEmail = null">
    </app-change-email>
  }
